import { remify } from '@dynamic/ui';
import styled from 'styled-components';

import { FormButtonContainer } from '../Form/Form.styled';
import { Container as FormInputContainer } from '../Form/FormInput/FormInput.styled';
import { Modal } from '../Modal/Modal';

export const Container = styled.div`
  & ${FormButtonContainer} {
    margin: 0 0 ${remify(16)} 0;
  }

  & ${FormInputContainer} {
    margin: 0 0 ${remify(32)} 0;
  }
`;

export const ExtraOptions = styled.div`
  display: flex;
  justify-content: space-between;
  font: var(--fontStyleFootnote);
  color: var(--dialogParagraphForeground);
  align-items: center;

  & ${FormInputContainer} {
    margin: 0;
    flex: 0 1 auto;
    width: auto;
  }
`;

ExtraOptions.displayName = 'ExtraOptions';

export const RegistrationSection = styled.div`
  margin: 1.5rem 0 0.5rem;
  font: var(--fontStyleBody);
  color: var(--dialogParagraphForeground);
`;

RegistrationSection.displayName = 'RegistrationSection';

export const SpinnerContainer = styled.div`
  text-align: center;
  margin: 2rem 1rem 4rem;
`;

export const LoginModal = styled(Modal)`
  width: 100%;
  max-width: 25rem;
  background-color: var(--pageSecondaryBackground);
  text-align: center;
`;

export const PageHeading = styled.h2`
  font: var(--fontStyleHeadline);
  color: var(--pageHeadingForeground);
  margin: ${remify(15)} 0 ${remify(45)};
  text-align: center;
`;
